import styled, { css } from 'styled-components'
import { stripUnit } from 'polished'
import theme from 'styles/theme'
import { display } from 'styled-system'
import { GatsbyImage } from 'gatsby-plugin-image'

export const CarouselOutline = styled.div`
  ${(props) =>
    `transform: translate(${
      props.rtl ? -props.carouselXOffset : props.carouselXOffset
    }px, ${0}px)`};
`

export const CarouselWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  & * {
    outline: none;
  }

  .slick-slide > div {
    position: relative !important;
  }

  .slick-track {
    margin: 0 auto;
    display: flex;
    align-items: stretch;
    height: initial;
  }

  .slick-slide {
    padding-bottom: 0 !important;
    height: auto !important;
    min-height: 100%;

    > div,
    > div > div {
      height: 100%;
    }
  }

  .slick-slider {
    overflow: visible;
  }

  ${(props) =>
    props.multipleView &&
    `max-width: ${theme.containterMaxWidth};
    margin: 0 auto;
    width: calc(100% - ${stripUnit(theme.space[3]) * 2}em);

    ${theme.mediaQueries.medium} {
      width: calc(100% - ${stripUnit(theme.space[3]) * 2}em);
    }

    ${theme.mediaQueries.large} {
      width: 100%;
    }

    html[dir='rtl'] & {
      text-align: right;
    }

    .slick-list {
      overflow: visible;
    }

    .gatsby-image-wrapper {
      height: 500px;
    }

    .slick-slide {
      padding: 0 0 0 ${theme.space[0]};
      width: 339px !important;

      ${theme.mediaQueries.medium} {
        padding: 0 0 0 ${theme.space[0]};
        width: 501px !important;
      }

      ${theme.mediaQueries.large} {
        padding: 0 ${theme.space[3]};
        width: 341px !important;
      }
    }
  `}

  ${(props) =>
    props.multipleView &&
    `.slick-list {
      max-width: ${`${stripUnit(theme.containterMaxWidth) - 70 - 15}px`};

      ${theme.mediaQueries.large} {
        max-width: ${
          props.isCarouselWidthOverflowing
            ? `${stripUnit(theme.containterMaxWidth)}px`
            : `${stripUnit(theme.containterMaxWidth) - 177}px`
        };
        margin-left: auto;
        margin-right: auto;
      }
    }
  `}

  ${(props) =>
    !props.multipleView &&
    `::before {
      position: absolute;
      content: '';
      width: 100%;
      height: calc(100% - 1px);
      top: 0;
      left: 0;
    }
  `}
`

export const CarouselContainer = styled.div`
  overflow: hidden !important;
  position: relative;

  ${(props) =>
    props.multipleView &&
    props.background === 'Grey' &&
    `background: ${props.theme.colors.sagelight};
  `}

  ${(props) =>
    props.background?.match(/^#[0-9a-fA-F]{6}$/i) &&
    `background: ${props.background};`}

  ${(props) =>
    props.background === 'Sandstone' &&
    css`
      &[data-background='Sandstone']:has(+ *[data-background='White']),
      &[data-background='Sandstone']:has(+ *[data-background='Sandstone']) {
        border-bottom: 1px solid ${props.theme.colors.sagedarkToGreen};
      }
    `}
`

export const CtaRow = styled.div`
  text-align: center;

  a {
    ${theme.mediaQueries.medium} {
      min-width: 305px;
    }
  }
`

export const CarouselImageBackgroundContainer = styled.div`
  background-size: cover;
  background-position: center center;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;

  .gatsby-image-wrapper {
    height: calc(100% + 3px);
  }
`

export const CarouselImageBackground = styled(GatsbyImage)`
  ${display}
`
